export default class FrontUserExpressInfo {
    warehouseName: string;
    whetherHandle: boolean;
    userUploadImageGuid: string;
    goodsImageGuid: string;
    receiveStatus: number;
    orderNumber: number;
    shipment: string;
    reMark: string;
    rejectionTime?: Date;
    createTime: Date;
    signForTime?: Date;
    imageGuid: string;
    orderId?: number;
}